
export default function waitForValue(
  func: () => unknown, attempt = 1, maxAttempts = 10
): Promise<void | unknown> {
  return new Promise((resolve, reject) => {
    const value = func()
    if (value) {
      resolve(value)
    } else if (attempt < maxAttempts) {
      window.requestAnimationFrame(() => {
        waitForValue(func, attempt + 1)
          .then(v => resolve(v)).catch(() => reject())
      })
    } else {
      reject()
    }
  })
}
